import moment from "moment";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import { setDetailGood } from "./goods";
import { fetchRawsInventoryForm, getDataListInventory, getLastInventory } from "./inventoryforms";
import { fetchRaws, setDetailRaw } from "./raw";
import request from "./utils/request";
import { isEmpty } from "lodash";

export function fetchReceipe(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: true });
        dispatch(resetError('modalRecipe'));
        try {
            const recipe = await request({ method: 'get', url: `${urls.recipes}/${id}` });
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
            return recipe;
        } catch(error) {
            dispatch(setError(error, 'modalRecipe'));
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
        }
    }
}

export function fetchReceipes(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'receipes', value: true });
        dispatch(resetError('receipes'));
        try {
            const params = data ? data : {};
            if (!params._sort) params._sort = 'startDate:desc'
            const receipes = await request({ method: 'get', url: urls.recipes, params });
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            dispatch({ type: 'SET_RECEIPES', list: receipes });
            return receipes;
        } catch(error) {
            dispatch(setError(error, 'receipes'));
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            return null;
        }
    }
}

export function receipesCount(data) {
    return async (dispatch) => {
        try {
            const params = data ? data : null
            const count = await request({ method: 'get', url: `${urls.recipes}/count`, params });
            return count;
        } catch(error) {
            return null;
        }
    }
}

export function createReceipe(data) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: true });
        dispatch(resetError('modalRecipe'));
        try {
            const result = await request({ method: 'post', url: urls.recipes, data });
            if (result) {
                const detail = data.type === 'semi' ? getState().raw.detail : getState().good.detail;
                const recipes = [...detail.recipes, result];
                const sortedRecipes = recipes.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
                if (data.type === 'semi') {
                    dispatch(setDetailRaw({ ...detail, recipes: sortedRecipes}))
                } else {
                    dispatch(setDetailGood({ ...detail, recipes: sortedRecipes}));
                }
            }
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
            return true;
        } catch(error) {
            dispatch(setError(error, 'modalRecipe'));
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
            return null;
        }
    }
}

export function importReceipes(list) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'receipesImport', value: true });
        try {
            const result = await Promise.all(list.map(async (data) => {
                const receipe = await request({ method: 'post', url: urls.recipes, data });
                return receipe.id;
            }));
            dispatch({ type: 'SET_LOADER', field: 'receipesImport', value: false });
            return result;
        } catch(error) {
            dispatch({ type: 'SET_LOADER', field: 'receipesImport', value: false });
            return null;
        }
    }
}

export function updateReceipe(data) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: true });
        dispatch(resetError('modalRecipe'));
        try {
            const result = await request({ method: 'put', url: `${urls.recipes}/${data.id}`, data });
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
            if (result) {
                const detail = data.type === 'semi' ? getState().raw.detail : getState().good.detail;
                const recipes = await detail.recipes.filter((receipe) => receipe.id !== data.id);
                const sortedRecipes = [...recipes, result].sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
                if (data.type === 'semi') {
                    dispatch(setDetailRaw({ ...detail, recipes: sortedRecipes}))
                } else {
                    dispatch(setDetailGood({ ...detail, recipes: sortedRecipes}));
                }
                return recipes;
            }
            return result;
        } catch(error) {
            dispatch(setError(error, 'modalRecipe'));
            dispatch({ type: 'SET_LOADER', field: 'modalRecipe', value: false });
            return null;
        }
    }
}

export function deleteReceipe(id, type) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'receipes', value: id });
        dispatch(resetError('receipes'));
        try {
            const result = await request({ method: 'delete', url: `${urls.recipes}/${id}` });
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            if (result) {
                const detail = type === 'semi' ? getState().raw.detail : getState().good.detail;
                const recipes = await detail.recipes.filter((receipe) => receipe.id !== id);
                const sortedRecipes = recipes.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
                if (type === 'semi') {
                    dispatch(setDetailRaw({ ...detail, recipes: sortedRecipes}))
                } else {
                    dispatch(setDetailGood({ ...detail, recipes: sortedRecipes}));
                }
                return recipes;
            }
            return true;
        } catch(error) {
            dispatch(setError(error, 'receipes'));
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            return null;
        }
    }
}

export function getReceipesByIngredient(id, type, ingredientType, returnReceipes) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'receipes', value: id });
        dispatch(resetError('receipes'));
        try {
            const params = { id: id };
            if (type) params.type = type;
            if (ingredientType) params.ingredientType = ingredientType;
            const result = await request({ method: 'get', url: `${urls.recipes}/getByIngredient`, params });
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            if (result) {
                const detail = getState().raw.detail;
                const sortedRecipes = result.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
                
                if (!returnReceipes) {
                    if (type === 'semi') {
                        dispatch(setDetailRaw({ ...detail, recipesSemi: sortedRecipes}))
                    } else {
                        dispatch(setDetailRaw({ ...detail, recipesGood: sortedRecipes}));
                    }
                    return true;
                }
                return sortedRecipes;
            }
            if (!returnReceipes) return true;
            return null;
        } catch(error) {
            dispatch(setError(error, 'receipes'));
            dispatch({ type: 'SET_LOADER', field: 'receipes', value: false });
            return null;
        }
    }
}

const getDataReceipe = (originalReceipe, dateActualReceipe) => {
    return async (getState, dispatch) => {
        if(isEmpty(originalReceipe) || isEmpty(originalReceipe.ingredients)) return [];
        const recipes = getState().recipes.list;
        const semis = originalReceipe.ingredients.filter((ingredient) => ingredient.type !== 'raw').map((item) => ({ ...item, count: { ...item.quantity } }));
        const dataReceipe = originalReceipe.ingredients.filter((ingredient) => ingredient.type === 'raw') || [];

        while (semis.length > 0) {
            const semi = semis.shift();
            const date = dateActualReceipe ? dateActualReceipe : new Date();
            try {
                const partsId = typeof semi.id === 'string' ? semi.id.split('_') : null;
                const semiId = (partsId && partsId[0]) ? parseInt(partsId[0]) : semi.id;
                const modId = (partsId && partsId[1]) ? parseInt(partsId[1]) : null;

                let receipe = recipes.find((item) => parseInt(item.productId) === semiId && item.type === semi.type && moment(item.startDate).toISOString <= moment(date).toISOString);
                if (!receipe) {
                    const params = { productId: semiId, type: semi.type, date };
                    receipe = await request({ method: 'get', url: urls.recipes + '/getActualReceipe', params });
                    if (receipe && !receipe.error) dispatch({ type: 'ADD_RECEIPE', item: receipe });
                }

                if (!receipe || receipe.error || !receipe.ingredients) continue;

                receipe.ingredients.forEach((ingredient) => {
                    const count = {};
                    Object.keys(semi.count).forEach(key => {
                        count[key] = parseFloat(semi.count[key] * ((ingredient.quantity && ingredient.quantity[modId ? modId : 'default']) || 1));
                    });
                    const dataIngredient = { ...ingredient, count };

                    if (ingredient.type === 'raw') {
                        dataReceipe.push(dataIngredient);
                    } else {
                        semis.push(dataIngredient);
                    }
                });
            } catch (err) {
                console.error(err);
            }
        }

        return dataReceipe;
    };
};


export function getGoodWithReceipeData(good, getActualReceipe = false, dateActualReceipe) {
    return async (dispatch, getState) => {
        const recipes = getState().recipes.list;
        let originalReceipe = null;
        if (!getActualReceipe) {
            originalReceipe = good.receipe;
            if (!originalReceipe && !isEmpty(recipes)) originalReceipe = recipes.find((item) => item.productId === good.id && item.type === (good.type || 'good'));
            if (!originalReceipe) return null;
        } else {
            const id = typeof good.id === 'number' ? +good.id : +good.id.split('_')[0];
            const params = {
                productId: id,
                type: good.type ? good.type : 'good',
                date: dateActualReceipe || null,
            };

            originalReceipe = await request({ method: 'get', url: urls.recipes + '/getActualReceipe', params });
            if (originalReceipe.error || isEmpty(originalReceipe)) return [];
        }
        
        const receipeData = good.receipeData ? good.receipeData : await getDataReceipe(originalReceipe, dateActualReceipe)(getState, dispatch);
        return receipeData;
    }
}

export function getGoodsWithReceipe(good, getAll) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_STATISTICS_LOADER', name: 'costprice', loading: true });
        dispatch({ type: 'SET_STATISTICS_ERROR', name: 'costprice', error: null });
        const filters = getState().statistics.costprice.filters;

        const params = getAll ? { type: filters.type, getAll } : filters;
        if (filters.category) params.category = filters.category;

        if (filters.type === 'semi') {
            const rawCategories = getState().raw.categories
            const semiCategories = rawCategories.filter((item) => item.type === 'semi');
            const semiCategoriesIds = semiCategories.map((category) => category.id);
            params.semiCategoriesIds = semiCategoriesIds;
        }

        try {
            const result = !good ? await request({ method: 'get', url: urls.recipes+'/getWithReceipe', params }) : { goods: [good] };
            
            if (result.goods && result.goods.length > 0) {
                result.goods.forEach((good) => {
                    if (good.receipe) dispatch({ type: 'ADD_RECEIPE', item: good.receipe });
                });

                const goodsWithReceipeData = await Promise.all(
                    result.goods.map(async (good) => {
                        if (good.receipe && good.receipe.ingredients) {                            
                            try {
                                const receipeData = await getDataReceipe(good.receipe)(getState, dispatch);
                                return { ...good, receipeData };
                            } catch (err) {
                                return { ...good, receipeData: null };
                            }
                        } else {
                            return good;
                        }
                    })
                );
                
                result.goods = goodsWithReceipeData;
            }
            
            dispatch({ type: 'SET_STATISTICS_LOADER', name: 'costprice', loading: false });
            return result;
        } catch (error) {
            dispatch({ type: 'SET_STATISTICS_ERROR', name: 'costprice', error });
            dispatch({ type: 'SET_STATISTICS_LOADER', name: 'costprice', loading: false });
            return {error: error};
        }
    };
}

export function getOrdersWithReceipes (orders, receipes, withReceipeData = true) {
    return async (dispatch) => {

        const getOrderGoodReceipe = (receipes, type, goodId, visible_datetime, created_at) => {
            return receipes.filter((receipe) => {
                if (receipe.type !== type) return false;
                if (receipe.productId !== goodId) return false;
                if (visible_datetime) {
                    if (new Date(receipe.startDate) > new Date(visible_datetime)) return false;
                } else {
                    if (new Date(receipe.startDate) > new Date(created_at)) return false;
                }
                return true;
            })
            .sort((a, b) => {
                const dateA = new Date(a.startDate).getTime();
                const dateB = new Date(b.startDate).getTime();
                return dateB - dateA;
            });
        }

        return await Promise.all(
            orders.map(async (order) => {
                const goods = JSON.parse(order.goods);
                
                const processedGoods = await Promise.all(
                    goods.map(async (good) => {
                        if (good.isWok && good.wokData) {
                            const { wokData } = good;
                            const { main, meat, topping, souce } = wokData;
                            let resultReceipe =  { ingredients: [] };
                            let receipeData = [];
                            if (main && main.id) {
                                const wokReceipes = getOrderGoodReceipe(receipes, 'good', main.id, order.visible_datetime, order.created_at);
                                const receipe = (wokReceipes && wokReceipes.length > 0) ? wokReceipes[0] : null;
                                if (receipe) {
                                    if (withReceipeData) {
                                        const receipeDataWok = await dispatch(getGoodWithReceipeData({...main, count: good.count, receipe}));
                                        const sumedReceipeData = receipeDataWok.map((raw) => {
                                            const quantity = raw.quantity.default * good.count;
                                            return {...raw, isMultiply: true, quantity: { default: quantity }}
                                        })
                                        receipeData.push(...sumedReceipeData);
                                    } else {
                                        resultReceipe.ingredients.push(...receipe.ingredients);
                                    }                                    
                                }
                            }
                            
                            if (meat && !isEmpty(meat)) {
                                Object.values(meat).forEach(async (item) => {
                                    const wokReceipes = getOrderGoodReceipe(receipes, 'good', item.data.id, order.visible_datetime, order.created_at);
                                    const receipe = (wokReceipes && wokReceipes.length > 0) ? wokReceipes[0] : null;
                                    if (receipe) {
                                        if (withReceipeData) {
                                            const receipeDataWok = await dispatch(getGoodWithReceipeData({...item, id: item.data.id, receipe}));
                                            const sumedReceipeData = receipeDataWok.map((raw) => {
                                                const quantity = raw.quantity.default * item.count;
                                                return {...raw, isMultiply: true, quantity: { default: quantity }}
                                            })
                                            receipeData.push(...sumedReceipeData);
                                        } else {
                                            resultReceipe.ingredients.push(...receipe.ingredients);
                                        }
                                    }
                                })
                            }

                            if (topping && !isEmpty(topping)) {
                                Object.values(topping).forEach(async (item) => {
                                    const wokReceipes = getOrderGoodReceipe(receipes, 'good', item.data.id, order.visible_datetime, order.created_at);
                                    const receipe = (wokReceipes && wokReceipes.length > 0) ? wokReceipes[0] : null;
                                    if (receipe) {
                                        if (withReceipeData) {
                                            const receipeDataWok = await dispatch(getGoodWithReceipeData({...item, id: item.data.id, receipe}));
                                            const sumedReceipeData = receipeDataWok.map((raw) => {
                                                const quantity = raw.quantity.default * item.count;
                                                return {...raw, isMultiply: true, quantity: { default: quantity }}
                                            })
                                            receipeData.push(...sumedReceipeData);
                                        } else {
                                            resultReceipe.ingredients.push(...receipe.ingredients);
                                        }
                                    }
                                })
                            }

                            if (souce && !isEmpty(souce)) {
                                Object.values(souce).forEach(async (item) => {
                                    const wokReceipes = getOrderGoodReceipe(receipes, 'good', item.id, order.visible_datetime, order.created_at);
                                    const receipe = (wokReceipes && wokReceipes.length > 0) ? wokReceipes[0] : null;
                                    const count = item.count ? item.count * good.count : good.count;
                                    if (receipe) {
                                        if (withReceipeData) {
                                            const receipeDataWok = await dispatch(getGoodWithReceipeData({...item, count, receipe}));
                                            const sumedReceipeData = receipeDataWok.map((raw) => {
                                                const quantity = raw.quantity.default * count;
                                                return {...raw, isMultiply: true, quantity: { default: quantity }}
                                            })
                                            receipeData.push(...sumedReceipeData); 
                                        } else {
                                            resultReceipe.ingredients.push(...receipe.ingredients);
                                        }
                                    }
                                })
                            }

                            if (withReceipeData) return { ...good, receipeData, receipe: resultReceipe };
                            return { ...good, receipe: resultReceipe }; 
                        } else {
                            const goodId = typeof good.id === 'string' ? parseInt(good.id.split('_')[0]) : good.id;
                            const goodReceipes = getOrderGoodReceipe(receipes, 'good', goodId, order.visible_datetime, order.created_at);
                            const receipe = (goodReceipes && goodReceipes.length > 0) ? goodReceipes[0] : null;
                            if (receipe) {
                                const receipeData = await dispatch(getGoodWithReceipeData({...good, receipe}));
                                if (withReceipeData) return { ...good, receipe, receipeData };
                                return { ...good, receipe };
                            } else {
                                return { ...good, receipe: null, receipeData: null };
                            }
                        }
                    })
                );
                
                return { ...order, goods: processedGoods };
            })
        );
    }
}

export function getWriteoffsWithReceipes (writeoffs, receipes) {
    return async (dispatch) => {
        return await Promise.all(
            writeoffs.map(async (writeoff) => {
                const products = writeoff.products;
                if (!products) return writeoff;
                
                const processedProducts = await Promise.all(
                    products.map(async (product) => {
                        if (product.type === 'raw') return { ...product, receipe: { id: product.id, quantity: { default: 1 } }, receipeData: [{ id: product.id, quantity: { default: 1 } }] };
                        const productId = typeof product.id === 'string' ? parseInt(product.id.split('_')[0]) : product.id;
                        
                        const productReceipes = receipes.filter((receipe) => {
                            if (receipe.type !== product.type) return false;
                            if (receipe.productId !== productId) return false;
                            if (new Date(receipe.startDate) > new Date(writeoff.created_at)) return false;                                    
                            return true;
                        })
                        .sort((a, b) => {
                            const dateA = new Date(a.startDate).getTime();
                            const dateB = new Date(b.startDate).getTime();
                            return dateB - dateA;
                        });
                        
                        const receipe = (productReceipes && productReceipes.length > 0) ? productReceipes[0] : null;
                        
                        if (receipe) {
                            const receipeData = await dispatch(getGoodWithReceipeData({...product, receipe}));
                            return { ...product, receipe, receipeData };
                        } else {
                            return { ...product, receipe: null, receipeData: null };
                        }
                    })
                );
                
                return { ...writeoff, products: processedProducts };
            })
        );
    }
}

export const calculateRawComing = (invoices, rawId) => {
    const rawInvoices = invoices.filter((invoice) => 
        invoice.rawMaterials && 
        invoice.rawMaterials.length > 0 && 
        invoice.rawMaterials.find((el) => el.id === rawId)
    ).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    const coming = rawInvoices.reduce((acc, invoice) => {
        const dataRaw = invoice.rawMaterials.find((el) => el.id === rawId);
        return acc + (dataRaw.quantity || 0);
    }, 0);
    return coming;
}

const filterGoodsByRaw = (good, rawId) => {
    if (good.type && good.type === 'raw') return true;
    if (!good.receipeData) return false;
    const hasRaw = good.receipeData.filter((el) => el.id === rawId);
    if (!hasRaw || hasRaw.length === 0) return false;
    return true;
}

export const calculateRawExpenditure = (ordersWithReceipes, rawId) => {
    const result = ordersWithReceipes.filter((order) => {
        const goods = order.goods.filter((good) => filterGoodsByRaw(good, rawId));
        if (!goods || goods.length <= 0) return false;
        return true;
    }).reduce((acc, order) => {
        const goods = order.goods.filter((good) => filterGoodsByRaw(good, rawId));
        const expenditure = goods.reduce((accGood, good) => {
            const dataRaw = good.receipeData.filter((el) => el.id === rawId);
            const field = typeof good.id === 'string' ? parseInt(good.id.split('_')[1]) || 'default' : 'default';

            const sumRaw = dataRaw.reduce((sum, data) => {
                if (data.count) {
                    const quantity = data.count[field] ? data.count[field] : 0;
                    sum += data.isMultiply ? quantity : quantity * good.count;
                } else {
                    const quantity = data.quantity && data.quantity[field] ? data.quantity[field] : 0;
                    sum += data.isMultiply ? quantity : quantity * good.count;
                }
                return sum;
            }, 0);
            
            accGood += sumRaw;
            return accGood;
        }, 0);

        return acc + (expenditure || 0)
    }, 0);

    return result;
}

export const calculateRawWriteoff = (writeoffsWithReceipes, rawId) => {
    const writeoff = writeoffsWithReceipes.filter((writeoff) => {
        if (!writeoff.products) return false;
        const products = writeoff.products.filter((product) => filterGoodsByRaw(product, rawId));
        if (!products || products.length <= 0) return false;
        return true;
    }).reduce((acc, writeoff) => {
        const products = writeoff.products.filter((product) => filterGoodsByRaw(product, rawId));
        const expenditure = products.reduce((accGood, product) => {
            const dataRaw = product.receipeData.filter((el) => el.id === rawId);
            const field = typeof product.id === 'string' ? parseInt(product.id.split('_')[1]) || 'default' : 'default';
            const sumRaw = dataRaw.reduce((sum, data) => {
                if (data.count) {
                    const quantity = data.count[field] ? data.count[field] : 0;
                    sum += quantity;
                } else {
                    const quantity = data.quantity && data.quantity[field] ? data.quantity[field] : 0;
                    sum += quantity;
                }
                return sum;
            }, 0);

            accGood += (sumRaw * product.quantity);
            return accGood;
        }, 0);

        return acc + (expenditure || 0)
    }, 0);

    return writeoff;
}

export function getBalancePoints (filters) {
    return async (dispatch, getState) => {
        const raws = getState().raw.list;
        const filialsData = getState().handbook.filials;
        const filials = filialsData.filter((point) => point.enableConsumption);
        const points = filials.slice(filters._start, filters._limit);

        const raw = raws.find((item) => item.id === filters.raw);
        
        const result = await Promise.all(
            points.map(async (point) => {
                const lastInventory = await dispatch(getLastInventory({id: point.id}));
                if (isEmpty(lastInventory)) return { ...raw, point, coming: 0, expenditure: 0, writeoff: 0, sum: 0, prevInventory: null, error: 'Для расчетов необходимо провести инвентаризацию.' }

                const dataFilters = {
                    point: point.id,
                    date_lte: filters.date_lte,
                    date_gt: new Date(lastInventory.date),
                }

                const balanceRaw = await dispatch(getBalanceRawPoints(raw, dataFilters, lastInventory));

                return { ...balanceRaw, point }
            })
        );

        return { data: result, count: filials.length }
    }
}

function getBalanceRawPoints (raw, filters, lastInventory) {
    return async (dispatch, getState) => {
        const receipes = await request({ method: 'get', url: urls.recipes, params: { _limit: -1 } });

        const rawsIds = [raw.id]
        let goodsIds = [];
        let semisIds = [];
        let getWok = false;

        const ids = await dispatch(getUsedreceipesRaws(raw, receipes));
        if (ids) {
            if (ids.goodsIds) goodsIds.push(...ids.goodsIds);
            if (ids.semisIds) semisIds.push(...ids.semisIds);
            if (ids.getWok) getWok = true;
        }

        goodsIds = [...new Set(goodsIds)];
        semisIds = [...new Set(semisIds)];

        if (filters.date_gt > filters.date_lte) {
            const res = await dispatch(getLastInventoryRaw(raw, semisIds, lastInventory, filters.point))
            return {...res, error: `Показаны данные последней инвентаризации от ${moment(lastInventory.date).format('DD.MM.YYYY HH:mm')}`}
        }

        const params = {
            point: filters.point,
            date_lte: filters.date_lte,
            date_gt: filters.date_gt,
            _sort: 'id:desc',
        };
        

        const invoicesParams = {...params, rawsIds};
        const invoices = await getDataListInventory(invoicesParams, {method: 'post', url: `${urls.invoiceforms}/listInventory`});
        if (invoices.error) return invoices;
        const writeoffsParams = {...params, goodsIds, semisIds, rawsIds}
        const writeoffs = await getDataListInventory(writeoffsParams, {method: 'post', url: `${urls.writeoffs}/listInventory`});
        if (writeoffs.error) return writeoffs;

        const paramsOrders = {
            pointsId: [filters.point],
            created_at_lte: moment(filters.date_lte).format('YYYY-MM-DD HH:mm:ss'),
            created_at_gt: moment(filters.date_gt).format('YYYY-MM-DD HH:mm:ss'),
            _sort: 'id:desc',
            goodsIds,
            getWok,
        };

        const orders = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.orders}/listInventory`});
        if (orders.error) return orders;
        const archive = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.archive}/listInventory`});
        if (archive.error) return archive;
        const ordersData = [...orders, ...archive];

        const ordersWithReceipes = await dispatch(getOrdersWithReceipes(ordersData, receipes));

        const coming = calculateRawComing(invoices, raw.id);
        const expenditure = calculateRawExpenditure(ordersWithReceipes, raw.id);

        const writeoffsWithReceipes = await dispatch(getWriteoffsWithReceipes(writeoffs, receipes));
        const writeoff = calculateRawWriteoff(writeoffsWithReceipes, raw.id);

        let prevInventory = null;

        if (lastInventory && lastInventory.id) {
            const rawParams = {
                rawmaterial: raw.id,
                inventoryform: lastInventory.id,
            };
            
            const prevInventory = await request({ method: 'post', url: `${urls.rawmaterialsinventories}/prevInventory`, data: rawParams });
            raw.prevInventory = prevInventory ? prevInventory.quantity || 0 : 0;
        }

        const balance = (prevInventory || 0) + (coming || 0) - (expenditure || 0) - (writeoff || 0);
        
        let sum = 0;
        let count = balance;

        const rawInvoices = invoices.filter((invoice) => 
            invoice.rawMaterials && 
            invoice.rawMaterials.length > 0 && 
            invoice.rawMaterials.find((el) => el.id === raw.id)
        ).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        

        for (const invoice of rawInvoices) {
            if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) continue;

            const dataRaw = invoice.rawMaterials.find((el) => el.id === raw.id);
            if (!dataRaw) continue;
            
            sum += dataRaw.totalPrice;
            count -= dataRaw.quantity;
            if (count === 0) break;
        }

        if (count !== 0) raw.sum += count * raw.last_price;

        const result = { ...raw, coming, expenditure, writeoff, sum, prevInventory}
        return result;
    }
}

export function getLastInventoryRaw (raw, semisIds, lastInventory, point) {
    return async (dispatch) => {
        const rawDataFromSemis = [];

        const rawInventoryData = await dispatch(fetchRawsInventoryForm({ rawmaterial: raw.id, inventoryform: lastInventory.id}));
        const rawInventory = !isEmpty(rawInventoryData) ? rawInventoryData[0] : null;

        const semis = await Promise.all(
            semisIds.map(async (id) => {
                const semi = await dispatch(fetchRawsInventoryForm({ rawmaterial: id, inventoryform: lastInventory.id}));
                return !isEmpty(semi) ? semi[0] : null;
            }).filter((item) => item)
        );
    
        for (const semi of semis) {
            if (semi.rawmaterial && semi.rawmaterial.id) {
                const receipeData = await dispatch(getGoodWithReceipeData({id: semi.rawmaterial.id, type: 'semi' }, true, new Date(lastInventory.date)));
                if (receipeData.error) continue;
                receipeData.forEach((rawData) => {
                    let quantity = null;
                    if (rawData.count) {
                        quantity = rawData.count && (rawData.count['default'] || 0) * semi.quantity;
                    } else {
                        quantity = rawData.quantity && (rawData.quantity['default'] || 0) * semi.quantity;
                    }
                    rawDataFromSemis.push({ id: semi.id, quantity, isSemi: true });
                });
            }
        };
    
        if (!rawDataFromSemis || rawDataFromSemis.length === 0) return rawInventory;
        const quantity = rawDataFromSemis.reduce((acc, item) => {
            return acc += parseFloat(item.quantity) || 0
        }, (parseFloat(rawInventory.quantity) || 0));

        let sum = 0;
        let count = quantity;
        let invoicesIds = [];
        while (count !== 0) {
            const params = {
                point: point ? point : lastInventory.point,
                date_gt: new Date(lastInventory.date),
                _sort: 'date:desc',
                _limit: 1,
            };

            if (invoicesIds.length > 0) params['id_nin'] = invoicesIds;

            const invoiceData = await request({ method: 'get', url: urls.invoiceforms, params });
            const invoice = !isEmpty(invoiceData) ? invoiceData[0] : null;
            if (!invoice) break;
            invoicesIds.push(invoice.id);
            if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) continue;

            const dataRaw = invoice.rawMaterials.find((el) => el.id === raw.id);
            if (!dataRaw) continue;
            
            sum += dataRaw.totalPrice;
            count -= dataRaw.quantity;
            if (count === 0) break;
        }

        if (count !== 0) sum += count * raw.last_price;
        return { ...rawInventory, quantity, balance: quantity, sum };
    }
}

export function getBalanceRaws(filters, lastInventory) {
    return async (dispatch, getState) => {
        const receipes = await request({ method: 'get', url: urls.recipes, params: { _limit: -1 } });

        const paramsRaws = {
            _limit: filters._limit,
            _start: filters._start,
            _sort: filters._sort || 'id:asc',
        };

        const countParams = {};

        paramsRaws['productscategory.type'] = 'raw';
        countParams['productscategory.type'] = 'raw';

        if (filters.category) {
            paramsRaws['productscategory.id'] = filters.category;
            countParams['productscategory.id'] = filters.category;
        }

        if (filters.raw) {
            paramsRaws.id = filters.raw;
            countParams.id = filters.raw;
        }

        const raws = await dispatch(fetchRaws(paramsRaws, countParams));

        if (filters.date_gt > filters.date_lte) {
            const rawMaterials = await Promise.all(
                raws.data.map(async (raw) => {
                    let semisIds = [];
                    const ids = await dispatch(getUsedreceipesRaws(raw, receipes));
                    if (ids) {
                        if (ids.semisIds) semisIds = ids.semisIds;
                    }
                    const res = await dispatch(getLastInventoryRaw(raw, semisIds, lastInventory, filters.point))
                    return {...res, error: `Показаны данные последней инвентаризации от ${moment(lastInventory.date).format('DD.MM.YYYY HH:mm')}`}
                })
            )
            return { data: rawMaterials, count: raws.count }
        }

        const rawsIds = raws.data.map((raw) => raw.id);
        let goodsIds = [];
        let semisIds = [];
        let getWok = false;

        await raws.data.forEach(async (raw) => {
            const ids = await dispatch(getUsedreceipesRaws(raw, receipes));
            if (ids) {
                if (ids.goodsIds) goodsIds.push(...ids.goodsIds);
                if (ids.semisIds) semisIds.push(...ids.semisIds);
                if (ids.getWok) getWok = true;
            }
        });

        goodsIds = [...new Set(goodsIds)];
        semisIds = [...new Set(semisIds)];
        const params = {
            point: filters.point,
            date_lte: filters.date_lte,
            date_gt: filters.date_gt,
            _sort: 'id:desc',
        };

        const invoicesParams = {...params, rawsIds};
        const invoices = await getDataListInventory(invoicesParams, {method: 'post', url: `${urls.invoiceforms}/listInventory`});
        if (invoices.error) return invoices;
        const writeoffsParams = {...params, goodsIds, semisIds, rawsIds}
        const writeoffs = await getDataListInventory(writeoffsParams, {method: 'post', url: `${urls.writeoffs}/listInventory`});
        if (writeoffs.error) return writeoffs;

        const paramsOrders = {
            pointsId: [filters.point],
            created_at_lte: moment(filters.date_lte).format('YYYY-MM-DD HH:mm:ss'),
            created_at_gt: moment(filters.date_gt).format('YYYY-MM-DD HH:mm:ss'),
            _sort: 'id:desc',
            goodsIds,
            getWok,
        };

        const orders = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.orders}/listInventory`});
        if (orders.error) return orders;
        const archive = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.archive}/listInventory`});
        if (archive.error) return archive;
        const ordersData = [...orders, ...archive];

        const ordersWithReceipes = await dispatch(getOrdersWithReceipes(ordersData, receipes));

        const rawMaterials = await Promise.all(
            raws.data.map(async (item) => {
                const raw = { ...item };
 
                raw.coming = calculateRawComing(invoices, raw.id)
                raw.expenditure = calculateRawExpenditure(ordersWithReceipes, raw.id)

                const writeoffsWithReceipes = await dispatch(getWriteoffsWithReceipes(writeoffs, receipes));
                raw.writeoff = calculateRawWriteoff(writeoffsWithReceipes, raw.id);

                if (lastInventory && lastInventory.id) {
                    const rawParams = {
                        rawmaterial: raw.id,
                        inventoryform: lastInventory.id,
                    };
                    
                    const prevInventory = await request({ method: 'post', url: `${urls.rawmaterialsinventories}/prevInventory`, data: rawParams });
                    raw.prevInventory = prevInventory ? prevInventory.quantity || 0 : 0;
                }

                raw.balance = (raw.prevInventory || 0) + (raw.coming || 0) - (raw.expenditure || 0) - (raw.writeoff || 0);
                
                raw.sum = 0;
                
                if (raw.balance > 0) {
                    let count = raw.balance;
                    const rawInvoices = invoices.filter((invoice) => 
                        invoice.rawMaterials && 
                        invoice.rawMaterials.length > 0 && 
                        invoice.rawMaterials.find((el) => el.id === raw.id)
                    ).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    
                    for (const invoice of rawInvoices) {
                        if (!invoice.rawMaterials || invoice.rawMaterials.length === 0) continue;
    
                        const dataRaw = invoice.rawMaterials.find((el) => el.id === raw.id);
                        if (!dataRaw) continue;
                        
                        raw.sum += dataRaw.totalPrice;
                        count -= dataRaw.quantity;
                        if (count === 0) break;
                    }
    
                    if (count !== 0) raw.sum += count * raw.last_price;
                }
                
                return raw;
            })
        );

        return { data: rawMaterials, count: raws.count }
    }
}

export function getUsedreceipesRaws(raw, allRecipes) {
    return (dispatch, getState) => {
        const goods = getState().good.list;
        const settings = getState().settings.init.categories;
        const receipes = allRecipes.filter((receipe) => receipe.ingredients.find((ingredient) => ingredient.id === raw.id && ingredient.type === raw.productscategory.type));
        const goodsIds = [];
        const semisIds = [];
        let getWok = false;

        while (receipes.length > 0) {
            const receipe = receipes.shift();
            const { type, productId } = receipe;

            if (type === 'good') {
                const entity = goods.find((good) => good.id === productId);
                if (entity && entity.category && [settings.mainWok, settings.meatWok, settings.toppingWok, settings.souceWok].includes(entity.category.id)) getWok = true;
                if (entity && entity.modifications && entity.modifications.length > 0) {
                    let ids = [productId];
                    entity.modifications.forEach((mod) => {
                        if (mod.id) ids.push(`${productId}_${mod.id}`);
                    });
                    goodsIds.push(...ids);
                } else {
                    goodsIds.push(productId);
                }
            } else {
                semisIds.push(productId);
            }

            const receipesProduct = allRecipes.filter((receipe) => receipe.ingredients.find((ingredient) => ingredient.id === productId && ingredient.type === type));
            if (receipesProduct && receipesProduct.length > 0) receipes.push(...receipesProduct);
        }

        return { goodsIds: [...new Set(goodsIds)], semisIds: [...new Set(semisIds)], getWok };
    }
}

export function getBalanceSemi(filters) {
    const filterGoodsBySemi = (good, semiId) => {
        if (!good.receipe || !good.receipe.ingredients) return false;
        const hasSemi = good.receipe.ingredients.filter((el) => el.id === semiId && el.type === 'semi');
        if (!hasSemi || hasSemi.length === 0) return false;
        return true;
    }

    const calculateSemiExpenditure = (orders, semiId) => {
        if (isEmpty(orders)) return 0;
        const result = orders.filter((order) => {
            const goods = order.goods.filter((good) => filterGoodsBySemi(good, semiId));
            if (!goods || goods.length <= 0) return false;
            return true;
        }).reduce((acc, order) => {
            const goods = order.goods.filter((good) => filterGoodsBySemi(good, semiId));
            const expenditure = goods.reduce((accGood, good) => {
                if (isEmpty(good.receipe) || isEmpty(good.receipe.ingredients)) return accGood;
                const dataSemi = good.receipe.ingredients.filter((el) => el.id === semiId && el.type === 'semi');
                const field = typeof good.id === 'string' ? parseInt(good.id.split('_')[1]) || 'default' : 'default';
    
                const sumSemi = dataSemi.reduce((sum, data) => {
                    const quantity = data.quantity && data.quantity[field] ? data.quantity[field] : 0;
                    sum += data.isMultiply ? quantity : quantity * good.count;
                    return sum;
                }, 0);
                
                accGood += sumSemi;
                return accGood;
            }, 0);
    
            return acc + (expenditure || 0)
        }, 0);
    
        return result;
    }

    const calculateSemiWriteoff = (writeoffs, semiId) => {
        if (isEmpty(writeoffs)) return 0;

        const result = writeoffs.filter((writeoff) => {
            if (isEmpty(writeoff.products)) return false;
            const hasSemi = writeoff.products.filter((product) => product.id === semiId && product.type === 'semi');
            if (!hasSemi || hasSemi.length === 0) return false;
            return true;
        }).reduce((acc, writeoff) => {
            const dataSemi = writeoff.products.find((product) => product.id === semiId && product.type === 'semi');
            if (isEmpty(dataSemi) || !dataSemi.quantity) return acc;
            acc += +dataSemi.quantity;
            return acc;
        }, 0);

        return result;
    }

    return async (dispatch, getState) => {
        const receipes = await request({ method: 'get', url: urls.recipes, params: { _limit: -1, type: 'good' } });

        const paramsRaws = {
            _limit: filters._limit,
            _start: filters._start,
            _sort: filters._sort || 'id:asc',
        };

        const countParams = {};

        paramsRaws['productscategory.type'] = 'semi';
        countParams['productscategory.type'] = 'semi';

        if (filters.category) {
            paramsRaws['productscategory.id'] = filters.category;
            countParams['productscategory.id'] = filters.category;
        }

        if (filters.raw) {
            paramsRaws.id = filters.raw;
            countParams.id = filters.raw;
        }

        const raws = await dispatch(fetchRaws(paramsRaws, countParams));

        const rawsIds = raws.data.map((raw) => raw.id);
        let goodsIds = [];
        let getWok = false;

        await raws.data.forEach(async (raw) => {
            const ids = await dispatch(getUsedreceipesSemi(raw, receipes));
            if (ids) {
                if (ids.goodsIds) goodsIds.push(...ids.goodsIds);
                if (ids.getWok) getWok = true;
            }
        });

        goodsIds = [...new Set(goodsIds)];
        const params = {
            point: filters.point,
            date_lte: filters.date_lte,
            date_gt: filters.date_gt,
            _sort: 'id:desc',
        };
        
        const writeoffsParams = {...params, goodsIds, semisIds: rawsIds}
        const writeoffs = await getDataListInventory(writeoffsParams, {method: 'post', url: `${urls.writeoffs}/listInventory`});
        if (writeoffs.error) return writeoffs;

        const paramsOrders = {
            pointsId: [filters.point],
            created_at_lte: filters.date_lte,
            created_at_gt: filters.date_gt,
            _sort: 'id:desc',
            goodsIds,
            getWok,
        };

        const orders = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.orders}/listInventory`});
        if (orders.error) return orders;
        const archive = await getDataListInventory(paramsOrders, {method: 'post', url: `${urls.archive}/listInventory`});
        if (archive.error) return archive;
        const ordersData = [...orders, ...archive];

        const ordersWithReceipes = await dispatch(getOrdersWithReceipes(ordersData, receipes, false));
        const rawMaterials = await Promise.all(
            raws.data.map(async (item) => {
                const raw = { ...item };
                raw.expenditure = calculateSemiExpenditure(ordersWithReceipes, raw.id)
                raw.writeoff = calculateSemiWriteoff(writeoffs, raw.id);                
                return raw;
            })
        );

        return { data: rawMaterials, count: raws.count }
    }
}

export function getUsedreceipesSemi(semi, allRecipes) {
    return (dispatch, getState) => {
        const goods = getState().good.list;
        const settings = getState().settings.init.categories;
        const receipes = allRecipes.filter((receipe) => receipe.ingredients.find((ingredient) => ingredient.id === semi.id && ingredient.type === semi.productscategory.type));
        const goodsIds = [];
        let getWok = false;

        while (receipes.length > 0) {
            const receipe = receipes.shift();
            const { type, productId } = receipe;

            if (type === 'good') {
                const entity = goods.find((good) => good.id === productId);
                if (entity && entity.category && [settings.mainWok, settings.meatWok, settings.toppingWok, settings.souceWok].includes(entity.category.id)) getWok = true;
                if (entity && entity.modifications && entity.modifications.length > 0) {
                    let ids = [productId];
                    entity.modifications.forEach((mod) => {
                        if (mod.id) ids.push(`${productId}_${mod.id}`);
                    });
                    goodsIds.push(...ids);
                } else {
                    goodsIds.push(productId);
                }
            }
        }

        return { goodsIds: [...new Set(goodsIds)], getWok };
    }
}